import { FC } from 'react';
import '../ArticleComponent.scss';
import './Article6.scss';
import { Section1, Section2, Images, Links } from './article6_model';
const handleImgNewHope = () => {
	window.open(Links.standard_home, '_blank', 'noopener');
};
const handleImgMarketInsight = () => {
	window.open(Links.market_ready_insights, '_blank', 'noopener');
};
const handleImgMarketVerified = () => {
	window.open(Links.market_ready_verified, '_blank', 'noopener');
};
const handleImgBeaconDiscovery = () => {
	window.open(Links.beacon_discovery, '_blank', 'noopener');
};
const Article6Component: FC = () => {
	return (
		<div className='page'>
			<div className='section--intro six-first'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section1.heading}</h3>
					<p className='info-600'>{Section1.para1}</p>
					<p className='info-400'>
						<span>{Section1.para2.content1}</span>
						<a href={Links.newhope} target='_blank' rel='noopener'>
							{Section1.para2.content2_link}
						</a>
						<span>{Section1.para2.content3}</span>
						<a href={Links.standards} target='_blank' rel='noopener'>
							{Section1.para2.content4_link}
						</a>
						<span>{Section1.para2.content5}</span>
					</p>{' '}
					<br></br>
					<br></br>
					<p className='info-400'>
						<span>{Section1.para3.content1}</span>
						<a href={Links.market_ready_insights} target='_blank' rel='noopener'>
							{Section1.para3.content2_link}
						</a>
						<span>{Section1.para3.content3}</span>
					</p>
				</div>
			</div>
			<div className='image-row'>
				<img src={Images.newhope_standards} onClick={handleImgNewHope} />
				<img src={Images.market_ready_insights} onClick={handleImgMarketInsight} />
				<img src={Images.beacon_discovery} onClick={handleImgBeaconDiscovery} />
				<img src={Images.market_ready_verified} onClick={handleImgMarketVerified} />
			</div>

			<div className='section--noimage'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section2.heading}</h3>
					<p className='info-600'>{Section2.para1}</p>
					<p className='info-400'>{Section2.para2}</p>
					<br></br>
					<br></br>
					<p className='info-400'>
						<span>{Section2.para3.content1}</span>
						<a href={Links.market_ready_verified} target='_blank' rel='noopener'>
							{Section2.para3.content2_link}
						</a>
						<span>{Section2.para3.content3}</span>
					</p>
				</div>
			</div>
		</div>
	);
};

export default Article6Component;
